import { PARISH } from "@/lib/constants";

/*
 * Media & Photography Privacy Policy, content supplied by the parish.
 * Sourced from `Website & Social Media & Photograph.txt` (2026-08-18).
 */
const Section = ({ title, children }) => (
    <section className="mt-8">
        <h2 className="font-serif text-2xl text-maroon-800">{title}</h2>
        <div className="gold-divider my-3 opacity-60" />
        <div className="space-y-3 text-maroon-700/90 leading-relaxed">{children}</div>
    </section>
);

const PrivacyPolicy = () => (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14" data-testid="privacy-policy-page">
        <span className="eyebrow">Legal</span>
        <h1 className="heading-section mt-1">Media &amp; Photography Privacy Notice</h1>
        <p className="mt-3 text-maroon-700/80">
            Holy Trinity Catholic Church, Kileleshwa, Archdiocese of Nairobi
        </p>

        <div className="gold-divider mt-5 opacity-60" />

        <p className="mt-5 italic text-maroon-700/85">
            By attending our masses and other events, you agree to our Media &amp; Photography Privacy
            Policy. Please read the notice below in full.
        </p>

        <Section title="Capturing of Images and Video">
            <p>
                In accordance with the Data Protection Act, 2019 and Article 31 of the Constitution of
                Kenya, please be advised that Holy Trinity Catholic Church (HTCC) Kileleshwa regularly
                photographs, films, and live-streams activities across all church facilities and
                organized functions. This includes Sunday masses, Small Christian Community (SCC)
                gatherings, parish ministry / group events, youth and children&apos;s programs, and
                outreach activities.
            </p>
        </Section>

        <Section title="Purpose of Use">
            <p>
                Photographs, audio recordings, and video footage taken during these events may be
                published or broadcast on Holy Trinity&apos;s official digital and print platforms.
                These include, but are not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-1">
                <li>Official website and web streaming channels.</li>
                <li>Official social media platforms (e.g., Facebook, Instagram, YouTube, X/Twitter).</li>
                <li>Official communication groups (e.g., WhatsApp broadcast lists, community groups).</li>
                <li>Print bulletins, newsletters, posters, and archdiocesan/diocesan publications.</li>
            </ul>
            <p>
                These materials are processed strictly for church archives, evangelization, community
                engagement, and informational purposes.
            </p>
        </Section>

        <Section title="Consent and Opt-Out Right">
            <p>
                By attending services or participating in Holy Trinity Catholic Church events, you
                acknowledge that your image or voice may be captured. However, you reserve the right
                to object to the recording or publication of your personal data at any time:
            </p>
            <p>
                <strong className="text-maroon-800">During Events:</strong> If you prefer not to be
                photographed or filmed, please notify the media team and church officials.
            </p>
            <p>
                <strong className="text-maroon-800">Post-Publication Removal:</strong> If an image or
                video featuring you or your dependent has been posted on our website, social media
                pages, or WhatsApp channels, you may request its prompt removal by contacting the
                Church at{" "}
                <a
                    href={`mailto:${PARISH.emails.info}`}
                    className="underline decoration-gold-400 underline-offset-4 hover:text-maroon-900"
                >
                    {PARISH.emails.info}
                </a>
                .
            </p>
        </Section>

        <Section title="Protection of Minors">
            <p>
                Holy Trinity Catholic Church takes the privacy of children seriously. Specific
                registration forms featuring explicit parental/guardian consent will be administered
                for specialized youth and children&apos;s activities (e.g., Sunday School, youth
                camps, retreats, etc.) before publishing close-up photos or identifying details of
                minors.
            </p>
        </Section>

        <div className="mt-10 rounded-2xl border border-maroon-100 bg-cream-50 p-6">
            <p className="text-sm text-maroon-700/85">
                Questions or requests concerning this notice can be sent to{" "}
                <a href={`mailto:${PARISH.emails.info}`} className="underline decoration-gold-400 underline-offset-4 hover:text-maroon-900">
                    {PARISH.emails.info}
                </a>
                .
            </p>
        </div>
    </div>
);

export default PrivacyPolicy;
